// Native text, with only enough aria-hidden copies to cover one complete loop.
if (!customElements.get('booie-marquee')) {
  customElements.define('booie-marquee', class extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('.booie-marquee__source');
      this.track = this.querySelector('.booie-marquee__track');
      if (!this.source || !this.track) return;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.observer.observe(this.source);
      this.contentObserver = new MutationObserver(this.schedule);
      this.contentObserver.observe(this.source, {subtree: true, childList: true, characterData: true});
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.contentObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    refresh() {
      const width = this.source.getBoundingClientRect().width;
      if (!width || !this.clientWidth) return;
      const copies = Math.ceil(this.clientWidth / width);
      const signature = [this.source.innerHTML, width, copies].join('|');
      if (signature === this.signature) return;
      this.track.querySelectorAll('[data-marquee-copy]').forEach(el => el.remove());
      for (let i = 0; i < copies; i++) {
        const copy = this.source.cloneNode(true);
        copy.classList.remove('booie-marquee__source');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('data-marquee-copy', '');
        this.track.appendChild(copy);
      }
      this.style.setProperty('--marquee-width', width + 'px');
      this.style.setProperty('--marquee-duration', (width / 110) + 's');
      this.setAttribute('data-ready', '');
      this.signature = signature;
    }
  });
}
